"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "strings/5.0.1";
